const newsCategoryServiceName = "/NewsCategory";

export function newsCategoriesService (http)  {
    return {
        getAllNewCategoriesAsync: async () => {
            return await http.get(newsCategoryServiceName + '/GetAllNewCategoriesAsync');
        }
    }
}